import React from 'react';
import { Icon } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const ScreenRecordingFootnote = props => (
  <span>
    {props.showUploadButton && (
      <span className="mr-4">{props.i18n.screen_recording.able_to_record}</span>
    )}
    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
    <span className="c-brand-blue h-td-u c-p" onClick={props.loadIlosRecording}>
      {props.showUploadButton
        ? props.i18n.screen_recording.upload
        : `${props.i18n.screen_recording.try_again} `}
    </span>
    {!props.showUploadButton && props.token && (
      <span>
        {props.i18n.common.or}&nbsp;
        <a href={`https://app.ilosvideos.com/recorder/download/${props.token}`}>
          {props.i18n.screen_recording.download}
        </a>
        .
      </span>
    )}
  </span>
);
const SkippedMessage = props => {
  if (props.finished) {
    return (
      <Text variant={TEXT_VARIANTS.BODY}>
        {props.i18n.video_response.skipped.finished.learner}
      </Text>
    );
  }
  if (
    props.showUploadButton ||
    (!props.hasIlosFeature && props.isWebcamRecording)
  ) {
    return (
      <Text variant={TEXT_VARIANTS.BODY}>
        {props.i18n.video_response.mobile_or_unsupported_skip}
      </Text>
    );
  }
  if (props.isWebcamRecording) {
    return (
      <Text variant={TEXT_VARIANTS.BODY}>
        {props.i18n.webcam_recording.skip}
      </Text>
    );
  }
  return (
    <Text variant={TEXT_VARIANTS.BODY}>
      {props.i18n.video_response.mobile_or_unsupported_skip}
    </Text>
  );
};

const Skipped = props => {
  const { finished, isScreenRecording, i18n } = props;
  return (
    <div className="Response-skipped lh-24">
      <div className="Response-skippedMessage d-f ai-c">
        <Icon name="skipped" className="mr-8" />
        <div>
          <SkippedMessage {...props} />
          {finished && i18n.video_response.skipped.finished.notified}
        </div>
      </div>
      {!finished && (
        <>{isScreenRecording && <ScreenRecordingFootnote {...props} />}</>
      )}
    </div>
  );
};

export default Skipped;
